import get from 'lodash/get';
import { BlogItem } from 'pages/api/blogApi.types';
import PageBackground from 'components/atoms/PageBackground/PageBackground';
import { BlogOverview } from 'components/organisms/BlogOverview';
import Header from 'components/organisms/Header/Header';
import { Footer } from 'components/organisms/Footer';
import TemplateWrapper from './partials/TemplateWrapper';
import { PageTemplateProps } from 'types/pages';
import { HeaderSpacer } from 'components/atoms/HeaderSpacer';

interface BlogsTemplateProps extends PageTemplateProps {
  blogs: BlogItem[];
}

const BlogsTemplate: React.FC<BlogsTemplateProps> = ({ data, header, footer, blogs }) => {
  const { alternate_languages } = data;

  return (
    <TemplateWrapper pageId={data.id} data={data}>
      <PageBackground />
      <Header {...header} alternateLanguages={alternate_languages} />
      <HeaderSpacer />
      <BlogOverview data={data} blogs={blogs} />
      <Footer data={get(footer, 'data.body', [])} />
    </TemplateWrapper>
  );
};

export default BlogsTemplate;
